<template>
  <article>
    <p>{{ text }}</p>
  </article>
</template>
<script setup lang="ts">
interface Props {
  text: string;
}
defineProps({
  text: null
});
</script>
<style lang="scss" scoped>
article {
  @include stroke('n', 'n');

  max-height: 15vh;
  overflow-y: auto;
  border-color: var(--color_neutral_200);
  background-color: var(--color_neutral_60);
  p {
    padding: 0.6rem;
  }

  word-break: break-word;
  white-space: pre-line;

  &::-webkit-scrollbar {
    width: 0.5rem;
  }
  &::-webkit-scrollbar-thumb,
  &::-webkit-scrollbar-track {
    border-radius: 0.25rem;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--color_neutral_500);
  }

  &::-webkit-scrollbar-track {
    background: var(--color_neutral_100);
  }
}
</style>
